<template>
  <b-container fluid id="wrapper-login" class="p-0" :style="{ backgroundImage: `url(${bgImage})` }">
    <b-row no-gutters>
      <b-col class="col-left hv-100" v-bind:style="{ background: loginBgColor, textAlign: loginTextAlign  }">
        <router-link to="/" class="d-flex" v-bind:style="{ justifyContent: loginLogoJustifyContent }">
          <b-img :src="logoHomeImg" fluid alt="Logo" v-bind:style="{ width: loginLogoWidth }" class="logoSite"/>
        </router-link>
        <div v-if="authMode === 'session'">
          <h4 class="mt-4">{{ $t('sign_in') }}</h4>
          <div v-if="isAuthenticated">
            <button id="session-is-authenticated" class="btn btn-primary btn-margin mt-3 buttonLogin" @click="logout()">
              <i class="mdi mdi-login"></i>
              Log Out
            </button>
          </div>
          <div v-else-if="sentRestoreEmailSuccessfully" class="mt-3">
            <p>
              Se envió un e-mail a tu casilla con los pasos para crear una nueva contraseña.
            </p>
          </div>
          <div v-else>
            <LmComponentLoading v-if="loading"/>
            <LmTextInput
              @enter="onSubmit"
              v-model="form.username"
              :v="$v.form.username"
              :label="$t('username')"
              />
            <LmPassword
              @enter="onSubmit"
              v-model="form.password"
              :v="$v.form.password"
              :serverErrorMessage="serverErrorMessage"
              :label="$t('password')"
              v-if="!forgotPasswordMode"
              />
            <button
              autofocus
              id="session-is-authenticated-else"
              class="btn btn-primary btn-margin mt-3 buttonLogin"
              @click="onSubmit"
            >
              <i class="mdi mdi-login"></i>
              {{ forgotPasswordMode ? 'Restablecer contraseña' :$t('sign_in_btn') }}
            </button>
            <button
              v-if="enableForgotPassword"
              class="btn btn-text mt-3"
              @click="forgotPasswordMode = !forgotPasswordMode"
            >
              {{ !forgotPasswordMode ? $t('forgot_password_btn') : $t('sign_in_btn') }}
            </button>
          </div>
        </div>
        <div v-else>
          <h4 class="mt-4">{{ $t('sign_in') }}</h4>
          <p class="mt-2">{{ $t('sign_in_message') }}</p>
          <button autofocus id="else-sign-in" class="btn btn-primary btn-margin mt-3 buttonLogin" v-if="!isAuthenticated" @click="login()">
            <i class="mdi mdi-login"></i>
            {{ $t('sign_in_btn') }}
          </button>
          <button id="log-out" class="btn btn-primary btn-margin mt-3 buttonLogin" v-if="isAuthenticated" @click="logout()">
            <i class="mdi mdi-login"></i>
            Log Out
          </button>
        </div>
      </b-col>
      <b-col class="col-right hv-100 d-none d-xl-block">
        <div class="auth-user-testimonial">
          <h2 class="mb-3">{{ title1 }}</h2>
          <p class="lead">
            <i class="mdi mdi-format-quote-open"></i>
            {{ text }}
            <i class="mdi mdi-format-quote-close"></i>
          </p>
          <p>{{ title2 }}</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import store from '@/store'
import { mapState, mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  name: 'app',
  components: {
    LmTextInput,
    LmPassword
  },
  mixins: [lmToasts],
  data () {
    return {
      form: {
        username: '',
        password: null
      },
      serverErrorMessage: '',
      loading: false,
      sentRestoreEmailSuccessfully: false,
      forgotPasswordMode: false,
      enableForgotPassword: process.env?.VUE_APP_ENABLE_FORGOT_PASSWORD === 'yes'
    }
  },
  validations: {
    form: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    ...mapActions('notifications', ['getNotifications']),
    onSubmit () {
      this.forgotPasswordMode ? this.onForgotPassword() : this.login()
    },
    async onForgotPassword () {
      this.$v.form.$touch()
      if (!this.$v.form.username.$invalid) {
        this.loading = true
        try {
          await commonsApi.axiosPostWrapper(
            process.env?.VUE_APP_FORGOT_PASSWORD_URL + this.form.username
          )
          this.loading = false
          this.sentRestoreEmailSuccessfully = true
        } catch (err) {
          // this.lmToastDangerMessage(err.response.data.message, `${err.response.data.type} - ${err.response.data.code}`)
        } finally {
          this.loading = false
        }
      }
    },
    login () {
      if (this.authMode === 'session') {
        this.$v.form.$touch()
        if (!this.$v.form.$pending && !this.$v.form.$error) {
          this.loading = true
          store.dispatch('session/login', { ...this.form })
            .then(r => {
              if (process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes') {
                this.getNotifications()
              }
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              if (typeof error.response.data.message !== 'undefined') {
                this.serverErrorMessage = error.response.data.message
                console.log('error.response.data.message', error.response.data.message)
              }
            })
        }
      } else {
        store.dispatch('session/login', {})
      }
    },
    logout () {
      store.dispatch('session/logout')
    }
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('settings', ['appName', 'logoHomeImg', 'title1', 'title2', 'text', 'bgImage', 'loginBgColor', 'loginLogoWidth', 'loginLogoJustifyContent', 'loginTextAlign']),
    authMode () {
      return process.env.VUE_APP_AUTH_MODE
    }
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.replace('/')
    }
  },
  mounted () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
#wrapper-login
  background-position: center
  background-size: cover
  .col-left
    padding: 48px 55px
    max-width: 480px
    width: 100%
    @media(max-width: $xl)
      max-width: none
      padding: 72px 56px
    .logoSite
      @media(max-width: $xl)
        margin: 0 auto
        display: block
    h4
      font-size: 18px
      font-weight: 700
      color: $primaryFontThemeColor
    p
      color: $mutedFontThemeColor!important
      font-size: 14px
      font-weight: 400
    .buttonLogin
      box-shadow: 0 2px 6px 0 rgba(114,124,245,.5)
      width: 100%
      color: #fff
      font-size: 14px
      font-weight: 400
  .col-right
    padding: 6rem 3rem
    -webkit-box-flex: 1
    -ms-flex: 1
    flex: 1
    position: relative
    color: #fff
    background-color: rgba(49,58,70,.6)
    text-align: center
    .auth-user-testimonial
      position: absolute
      margin: 0 auto
      padding: 0 1.75rem
      bottom: 3rem
      left: 0
      right: 0
      h2
        font-weight: 700
      p
        font-size: 14px
        &.lead
          font-weight: 400
          font-size: 18px
  .footer
    bottom: 0
    padding: 19px 30px 20px
    position: absolute
    right: 0
    color: $mutedFontThemeColor
    width: 100%
    text-align: center
</style>
